import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewFilterGroupToggleModelReturnType extends GTMEventReturnType {
    filter_group: string;
}

interface GTMOverviewFilterGroupToggleModelData {
    category: string;
}

export default class GTMOverviewFilterGroupToggleModel extends GTMBaseModel {
    public static parseToGTMData({
        category
    }: GTMOverviewFilterGroupToggleModelData): GTMOverviewFilterGroupToggleModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_filter_group_toggle',
            filter_group: category
        };
    }
}
